<template>
  <v-dialog
    v-model="navigation.dialogIsVisible"
    @update:model-value="navigation.dialogIsVisible == false ? closeDialog() : null"
    @contextmenu.prevent="null"
    :max-width="navigation.fullScreen ? '100vw' : '80vw'"
    :fullscreen="navigation.fullScreen"
    :retain-focus="false"
    scrim="black"
    opacity="0.8"
    style="user-select: none; cursor: default;"
  >
    <v-card 
      :style="navigation.fullScreen ? 'min-height: 100vh; height: 100vh; max-height: 100vh;' : (loader.startup ? 'min-height: 95vh; height: 95vh; max-height: 95vh;' : 'min-height: 0; height: auto; max-height: 95vh;')"
      style="display: flex; flex-direction: column; overflow: hidden;"
    >
      <v-card color="primary" rounded="0" elevation="0" class="headerCard">
        <div class="titleContainer">
          <v-icon color="indigo" size="large">mdi-source-branch-sync</v-icon>
          <template v-if="['insert', 'update', 'delete'].includes(navigation.action)">
            <v-icon color="indigo" style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.action] }}</v-icon>
          </template>
          <h3 style="margin-left: 10px;">{{ {'select': '', 'insert': 'REGISTRAR ', 'update': 'ACTUALIZAR ', 'delete': 'ELIMINAR '}[navigation.action] }}SEGUIMIENTO DE PRODUCTO{{ navigation.action != 'insert' ? ` ${navigation.CRMWhatsappProductFollowupID}` : ''}}</h3>
        </div>
        <div class="actionsContainer">
          <v-tooltip 
            :disabled="systemInformationData.tooltipDisabled"
            :text="navigation.fullScreen == false ? 'Mostrar en pantalla completa' : 'Salir de pantalla completa'"
            location="top"
          >
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                @click="navigation.fullScreen = !navigation.fullScreen"
                :disabled="loader.startup"
                size="x-large"
                class="hoverableVIcon"
              >
                {{ navigation.fullScreen == false ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>
            </template>
          </v-tooltip>
          <v-btn 
            @click="closeDialog()"
            :disabled="loader.startup"
            color="error" 
            class="hoverableVButton" 
          >
            <v-icon start>mdi-close-circle</v-icon>
            <p>CERRAR</p>
          </v-btn>
        </div>
      </v-card>
      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
      <template v-if="loader.startup">
        <div style="flex: 1; min-height: 0; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <AppLoaderScreen
            :appLogoSize="'x-small'"
            :loadingText="navigation.action == 'insert' ? 'Cargando información para registrar el seguimiento de producto' : 'Cargando seguimiento de producto'"
            :dotsToAnimate="3"
            style="width: 100%; height: 100%;"
          ></AppLoaderScreen>
        </div>
      </template>
      <template v-else>
        <div style="flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent; padding: 15px;">
          <template v-if="['select', 'delete'].includes(navigation.action)">
            <v-card elevation="2" style="border: 2px solid #343A40;">
              <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <v-icon color="indigo">mdi-account</v-icon>
                  <p><strong>Información del contacto</strong></p>
                </div>
              </v-card>
              <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
              <div class="twoColumnContainer" style="gap: 10px; padding: 15px;">
                <div style="display: flex; flex-direction: column; gap: 10px;">
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-barcode</v-icon>
                    <p><strong>ID:</strong> {{ display.CRMWhatsappProductFollowup.CRMWhatsappContactID }}</p>
                  </div>
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-card-account-details</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappContactSSN == null">
                      <p><strong>SSN:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                    </template>
                    <template v-else>
                      <p><strong>SSN:</strong> {{ display.CRMWhatsappProductFollowup.CRMWhatsappContactSSN }}</p>
                    </template>
                  </div>
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-account</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappContactName == null">
                      <p><strong>Nombre:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                    </template>
                    <template v-else>
                      <p><strong>Nombre:</strong> {{ display.CRMWhatsappProductFollowup.CRMWhatsappContactName }}</p>
                    </template>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px;">
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-phone</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappContactPhoneNumber == null">
                      <p><strong>Teléfono:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                    </template>
                    <template v-else>
                      <p><strong>Teléfono:</strong> {{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappProductFollowup.CRMWhatsappContactPhoneNumber) }}</p>
                    </template>
                  </div>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo">mdi-email</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappContactEmail == null">
                      <p><strong>Correo electrónico:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrado</span></p>
                    </template>
                    <template v-else>
                      <p><strong>Correo electrónico:</strong> {{ display.CRMWhatsappProductFollowup.CRMWhatsappContactEmail }}</p>
                    </template>
                  </div>
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-store</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappContactCRMLocalityID == null">
                      <p><strong>Localidad:</strong> <span style="font-size: x-small; color: #9e9e9e;">No registrada</span></p>
                    </template>
                    <template v-else>
                      <p><strong>Localidad:</strong></p>
                      <v-chip
                        :color="display.CRMWhatsappProductFollowup.CRMWhatsappContactCRMLocalityColor || 'primary'"
                        variant="flat"
                        elevation="2"
                        density="compact"
                        label
                        style="margin-left: 5px;"
                      >
                        <p>{{ display.CRMWhatsappProductFollowup.CRMWhatsappContactCRMLocalityName }}</p>
                      </v-chip>
                    </template>
                  </div>
                </div>
              </div>
            </v-card>
            <v-card elevation="2" style="border: 2px solid #343A40; margin-top: 15px;">
              <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <v-icon color="indigo">mdi-source-branch-sync</v-icon>
                  <p><strong>Información del seguimiento de producto</strong></p>
                </div>
              </v-card>
              <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
              <div class="twoColumnContainer" style="gap: 10px; padding: 15px;">
                <div style="display: flex; flex-direction: column; gap: 10px;">
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-barcode</v-icon>
                    <p><strong>ID:</strong> {{ display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupID }}</p>
                  </div>
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-source-branch</v-icon>
                    <p><strong>Estado:</strong></p>
                    <v-chip
                      :color="{'Pendiente (esperando al contacto)': 'error', 'Pendiente (esperando inventario)': 'error', 'Pendiente (otro)': 'error'}[display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupStatus]"
                      variant="flat"
                      elevation="2"
                      density="compact"
                      label
                      style="margin-left: 5px;"
                    >
                      <p>{{ display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupStatus }}</p>
                    </v-chip>
                  </div>
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-package</v-icon>
                    <p><strong>Inventario:</strong></p>
                    <v-chip
                      :color="display.CRMWhatsappProductFollowup.stockCRMWhatsappProductFollowupProductCount == 0 ? 'error' : (display.CRMWhatsappProductFollowup.stockCRMWhatsappProductFollowupProductCount == display.CRMWhatsappProductFollowup.totalCRMWhatsappProductFollowupProductCount ? 'success' : 'warning')"
                      variant="flat"
                      elevation="2"
                      density="compact"
                      label
                      style="margin-left: 5px;"
                    >
                      <p>{{ display.CRMWhatsappProductFollowup.stockCRMWhatsappProductFollowupProductCount == 0 ? 'Sin inventario' : (display.CRMWhatsappProductFollowup.stockCRMWhatsappProductFollowupProductCount == display.CRMWhatsappProductFollowup.totalCRMWhatsappProductFollowupProductCount ? 'Todos los productos tienen inventario' : 'Algunos productos tienen inventario') }}</p>
                    </v-chip>
                  </div>
                  <div style="display: flex; gap: 5px;">
                    <v-icon color="indigo">mdi-text-box</v-icon>
                    <p style="max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"><strong>Nota:</strong> 
                      <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupNote && /\S/.test(display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupNote)">
                        <span style="margin-left: 5px;">{{ display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupNote }}</span>
                      </template>
                      <template v-else>
                        <span style="font-size: x-small; color: #9e9e9e; margin-left: 5px;">Sin nota</span>
                      </template>
                    </p>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; gap: 10px;"> 
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo">mdi-account-plus</v-icon>
                    <p><strong>Creación:</strong></p>
                    <v-chip
                      :color="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCreationCRMAgentColor || 'primary'"
                      variant="flat"
                      elevation="2"
                      label
                      style="margin-left: 5px;"
                    >
                      <div style="display: flex; align-items: center;">
                        <img
                          :src="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCreationCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCreationCRMAgentProfilePictureURL"
                          :draggable="false"
                          style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                        >
                        <div style="display: flex; flex-direction: column;">
                          <p>{{ display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCreationCRMAgentName == null ? 'No registrado' : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCreationCRMAgentName }}</p>
                          <div style="display: flex; align-items: center; gap: 5px;">
                            <v-icon size="x-small">mdi-clock</v-icon>
                            <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCreationDatetime) }}</p>
                          </div>
                        </div>
                      </div>
                    </v-chip>
                  </div>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo">mdi-account-edit</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateCRMAgentID == null">
                      <p><strong>Actualización:</strong> <span style="font-size: x-small; color: #9e9e9e;">No actualizado</span></p>
                    </template>
                    <template v-else>
                      <p><strong>Actualización:</strong></p>
                      <v-chip
                        :color="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateCRMAgentColor || 'primary'"
                        variant="flat"
                        elevation="2"
                        label
                        style="margin-left: 5px;"
                      >
                        <div style="display: flex; align-items: center;">
                          <img
                            :src="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateCRMAgentProfilePictureURL"
                            :draggable="false"
                            style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                          >
                          <div style="display: flex; flex-direction: column;">
                            <p>{{ display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateCRMAgentName == null ? 'No registrado' : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateCRMAgentName }}</p>
                            <div style="display: flex; align-items: center; gap: 5px;">
                              <v-icon size="x-small">mdi-clock</v-icon>
                              <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupUpdateDatetime) }}</p>
                            </div>
                          </div>
                        </div>
                      </v-chip>
                    </template>
                  </div>
                  <div style="display: flex; gap: 5px; align-items: center;">
                    <v-icon color="indigo">mdi-account-check</v-icon>
                    <template v-if="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionCRMAgentID == null">
                      <p><strong>Finalización:</strong> <span style="font-size: x-small; color: #9e9e9e;">No finalizado</span></p>
                    </template>
                    <template v-else>
                      <p><strong>Finalización:</strong></p>
                      <v-chip
                        :color="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionCRMAgentColor || 'primary'"
                        variant="flat"
                        elevation="2"
                        label
                        style="margin-left: 5px;"
                      >
                        <div style="display: flex; align-items: center;">
                          <img
                            :src="display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionCRMAgentProfilePictureURL == null ? require('@/assets/images/CRMAgentProfilePicturePlaceholder.png') : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionCRMAgentProfilePictureURL"
                            :draggable="false"
                            style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;"
                          >
                          <div style="display: flex; flex-direction: column;">
                            <p>{{ display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionCRMAgentName == null ? 'No registrado' : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionCRMAgentName }}</p>
                            <div style="display: flex; align-items: center; gap: 5px;">
                              <v-icon size="x-small">mdi-clock</v-icon>
                              <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupCompletionDatetime) }}</p>
                            </div>
                          </div>
                        </div>
                      </v-chip>
                    </template>
                  </div>
                </div>
              </div>
            </v-card>
          </template>
          <template v-else>
            <v-autocomplete
              ref="CRMWhatsappProductFollowupStatus"
              v-model="input.CRMWhatsappProductFollowupStatus"
              :items="['Pendiente (esperando al contacto)', 'Pendiente (esperando inventario)', 'Pendiente (otro)']"
              :loading="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
              :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog || navigation.updateField != null"
              label="Estado del seguimiento"
              prepend-inner-icon="mdi-source-branch"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              chips
              closable-chips
              clearable
              hide-details
              hide-no-data
              style="margin-bottom: 15px;"
            >
              <template v-slot:chip="{ item }">
                <v-chip 
                  :color="{'Pendiente (esperando al contacto)': 'error', 'Pendiente (esperando inventario)': 'error', 'Pendiente (otro)': 'error', 'Finalizado': 'success', 'Cancelado': 'grey'}[item.value]"
                  elevation="2"
                  variant="flat"
                  label
                >
                  <p>{{ item.value }}</p>
                  <template v-slot:close>
                    <v-icon 
                      @click="input.CRMWhatsappProductFollowupStatus = null"
                      class="hoverableVIcon"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    @click="input.CRMWhatsappProductFollowupStatus = item.value"
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappProductFollowupStatus == item.value"
                    class="hoverableVListItem"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappProductFollowupStatus == item.value"
                        density="compact"
                        readonly
                        hide-details
                        class="hoverableVIcon"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <v-chip 
                      :color="{'Pendiente (esperando al contacto)': 'error', 'Pendiente (esperando inventario)': 'error', 'Pendiente (otro)': 'error', 'Finalizado': 'success', 'Cancelado': 'grey'}[item.value]"
                      density="dense"
                      variant="flat"
                      elevation="2"
                      label
                      style="margin-top: 5px; margin-bottom: 5px;"
                    >
                      <p>{{ item.value }}</p>
                    </v-chip>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
            <v-textarea
              v-model="input.CRMWhatsappProductFollowupNote"
              :loading="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
              :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog || navigation.updateField != null"
              label="Nota del seguimiento (opcional)"
              prepend-inner-icon="mdi-text-box"
              clear-icon="mdi-backspace"
              variant="outlined"
              density="compact"
              autocomplete="off"
              rows="3"
              no-resize
              clearable
              hide-details
              style="margin-bottom: 15px;"
            ></v-textarea>
          </template>
          <v-card elevation="2" style="border: 2px solid #343A40; margin-top: 15px;">
            <v-card color="primary" elevation="0" rounded="0" style="padding: 10px;">
              <div style="display: flex; align-items: center; gap: 10px;">
                <v-icon color="indigo">mdi-package</v-icon>
                <p><strong>Productos asociados</strong></p>
              </div>
              <template v-if="['insert', 'update'].includes(navigation.action)">
                <v-autocomplete
                  ref="productID"
                  v-model="input.productID"
                  v-model:search="input.searchedProductID"
                  @keydown.enter.prevent="input.productID = input.searchedProductID; appendProductIntoCRMWhatsappProductFollowupProduct();"
                  @update:model-value="appendProductIntoCRMWhatsappProductFollowupProduct()"
                  :loading="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
                  :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog || navigation.updateField != null"
                  :items="display.product"
                  item-value="productID"
                  item-title="productAutocompleteTitle"
                  label="Buscar o escanear producto"
                  prepend-inner-icon="mdi-barcode"
                  clear-icon="mdi-backspace"
                  variant="outlined"
                  density="compact"
                  autocomplete="off"
                  clearable
                  hide-no-data
                  hide-details
                  style="margin-top: 15px;"
                >
                  <template v-slot:item="{ props, item }">
                    <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                      <v-list-item 
                        v-bind="props" 
                        :title="null" 
                        :subtitle="null"
                        :active="input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductProductID == item.raw.productID) != null"
                        class="hoverableVListItem"
                      >
                        <template v-slot:prepend>
                          <v-checkbox-btn 
                            :model-value="input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductProductID == item.raw.productID) != null"
                            density="compact"
                            readonly
                            hide-details
                            class="hoverableVIcon"
                            style="margin-right: 10px;"
                          ></v-checkbox-btn>
                        </template>
                        <div style="display: flex; align-items: center; padding-left: 10px;">
                          <img
                            @click.stop="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': item.raw.productImageURL})"
                            :src="item.raw.productImageURL || require('@/assets/images/placeholderImage.png')"
                            draggable="false"
                            class="hoverableImage"
                            style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                          >
                          <div>
                            <p>{{ item.raw.productName }}</p>
                            <p style="font-size: smaller; color: #3F51B5;"><strong>{{ item.raw.productSKU }}</strong></p>
                          </div>
                        </div>
                      </v-list-item>
                    </v-list>
                  </template>
                </v-autocomplete>
              </template>
            </v-card>
            <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
            <template v-if="computed_CRMWhatsappProductFollowupProduct.length > 0">
              <v-data-table
                :headers="computed_CRMWhatsappProductFollowupProductHeaders"
                :items="computed_CRMWhatsappProductFollowupProduct"
                :hover="computed_CRMWhatsappProductFollowupProduct.length > 1"
                :items-per-page="navigation.action == 'insert' ? navigation.CRMWhatsappProductFollowupProductLimit : -1"
                :page="navigation.CRMWhatsappProductFollowupProductPage"
                fixed-header
                style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;"
              >
                <template v-slot:headers="{ columns }">
                  <tr>
                    <template
                      v-for="column in columns"
                      :key="column.value"
                    >
                      <th>
                        <v-card
                          :style="['select', 'delete'].includes(computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).value) ? 'display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%;' : 'display: flex; align-items: center; white-space: nowrap; height: 58px; width: 100%; padding: 0px 25px;'"
                          elevation="0"
                          rounded="0"
                        >
                          <template v-if="!['select', 'delete'].includes(computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).value)">
                            <template v-if="['select', 'delete'].includes(navigation.action) && computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).index > 0">
                              <v-icon 
                                @click="updateTableHeaderIndex('CRMWhatsappProductFollowupProduct', column.value, -1)"
                                color="tertiary"
                                size="x-small"
                                class="hoverableVIcon"
                                style="margin-right: 10px"
                              >
                                mdi-arrow-left-bold
                              </v-icon>
                            </template>
                            <v-icon color="indigo" style="margin-right: 5px;">{{ computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).icon }}</v-icon>
                            <template v-if="computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).visible">
                              <p style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).title }}</strong></p>
                            </template>
                            <template v-if="['select', 'delete'].includes(navigation.action)">
                              <v-icon 
                                @click="computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).visible = !computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).visible; updateTableVisibility('CRMWhatsappProductFollowupProduct')"
                                color="tertiary"
                                size="x-small"
                                class="hoverableVIcon"
                              >
                                mdi-{{ computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).visible ? 'eye' : 'eye-off' }}
                              </v-icon>
                            </template>
                            <template v-if="['select', 'delete'].includes(navigation.action) && computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).index < computed_CRMWhatsappProductFollowupProductHeaders.length - 1">
                              <v-icon
                                @click="updateTableHeaderIndex('CRMWhatsappProductFollowupProduct', column.value, 1)"
                                color="tertiary"
                                size="x-small"
                                class="hoverableVIcon"
                                style="margin-left: 10px"
                              >
                                mdi-arrow-right-bold
                              </v-icon>
                            </template>
                          </template>
                          <template v-else-if="computed_CRMWhatsappProductFollowupProductHeaders.find(header => header.value == column.value).value == 'select'">
                            <v-checkbox
                              v-model="input.allCRMWhatsappProductFollowupProductSelected"
                              @click="input.allCRMWhatsappProductFollowupProductSelected = !input.allCRMWhatsappProductFollowupProductSelected; input.CRMWhatsappProductFollowupProduct.forEach(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected = input.allCRMWhatsappProductFollowupProductSelected);"
                              color="indigo"
                              density="compact"
                              hide-details
                              class="hoverableVIcon"
                            ></v-checkbox>
                          </template>
                        </v-card>
                        <v-card color="grey-lighten-2" elevation="0" rounded="0" style="height: 1px;"></v-card>
                      </th>
                    </template>
                  </tr>
                </template>
                <template v-slot:item="row">
                  <tr
                    :class="getTableRowClass('CRMWhatsappProductFollowupProduct', row.item)" 
                    :style="loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog ? 'pointer-events: none;' : null"
                  >
                    <template
                      v-for="header in computed_CRMWhatsappProductFollowupProductHeaders"
                      :key="header.value"
                    >
                      <td @contextmenu.prevent="(['insert', 'update'].includes(navigation.action) && navigation.updateField == null) ? (row.item.selected = !row.item.selected, input.allCRMWhatsappProductFollowupProductSelected = input.CRMWhatsappProductFollowupProduct.every(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected)) : null">
                        <template v-if="header.value == 'select' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <v-checkbox-btn
                            v-model="row.item.selected"
                            @update:model-value="input.allCRMWhatsappProductFollowupProductSelected = input.CRMWhatsappProductFollowupProduct.every(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected);"
                            :disabled="navigation.updateField != null"
                            color="indigo"
                            density="compact"
                            hide-details
                            class="hoverableVIcon"
                          ></v-checkbox-btn>
                        </template>
                        <template v-else-if="header.value == 'delete' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <v-hover>
                            <template v-slot="{ isHovering, props: hoverProps }">
                              <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                <v-tooltip text="Eliminar producto del seguimiento de producto" location="top">
                                  <template v-slot:activator="{ props: tooltipProps }">
                                    <v-icon
                                      v-bind="tooltipProps"
                                      @click="input.CRMWhatsappProductFollowupProduct = input.CRMWhatsappProductFollowupProduct.filter(currentCRMWhatsappProductFollowupProduct => (currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductProductID != row.item.CRMWhatsappProductFollowupProductProductID) && currentCRMWhatsappProductFollowupProduct.selected == false); input.allCRMWhatsappProductFollowupProductSelected = false;"
                                      color="error"
                                      class="hoverableVIcon"
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                </v-tooltip>
                              </template>
                              <template v-else>
                                <v-icon
                                  v-bind="hoverProps"
                                  color="error"
                                  class="hoverableVIcon"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                            </template>
                          </v-hover>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupProductID' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <v-hover>
                            <template v-slot="{ isHovering, props: hoverProps }">
                              <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                <v-tooltip text="Copiar ID del producto del seguimiento de producto al portapapeles" location="top">
                                  <template v-slot:activator="{ props: tooltipProps }">
                                    <p 
                                      v-bind="tooltipProps"
                                      @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del producto del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupProductID)"
                                      class="hoverableVIcon"
                                      style="color: #3F51B5;"
                                    >
                                      <strong>{{ row.item.CRMWhatsappProductFollowupProductID }}</strong>
                                    </p>
                                  </template>
                                </v-tooltip>
                              </template>
                              <template v-else>
                                <p
                                  v-bind="hoverProps"
                                  @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'ID del producto del seguimiento de producto', 'o', row.item.CRMWhatsappProductFollowupProductID)"
                                  class="hoverableVIcon"
                                  style="color: #3F51B5;"
                                >
                                  <strong>{{ row.item.CRMWhatsappProductFollowupProductID }}</strong>
                                </p>
                              </template>
                            </template>
                          </v-hover>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupProduct' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <div style="display: flex; align-items: center; gap: 10px;">
                            <v-hover>
                              <template v-slot="{ isHovering, props: hoverProps }">
                                <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                                  <v-tooltip text="Ver imagen del producto" location="top">
                                    <template v-slot:activator="{ props: tooltipProps }">
                                      <img
                                        v-bind="tooltipProps"
                                        @click="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': row.item.productImageURL})"
                                        :src="row.item.productImageURL || require('@/assets/images/placeholderImage.png')"
                                        draggable="false"
                                        class="hoverableImage"
                                        style="width: 35px; height: 35px; border-radius: 50%; object-fit: cover; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                                      >
                                    </template>
                                  </v-tooltip>
                                </template>
                                <template v-else>
                                  <img
                                    v-bind="hoverProps"
                                    @click="$root.dialogControllerComponent.openDialog('imageDialog', {'imageURL': row.item.productImageURL})"
                                    :src="row.item.productImageURL || require('@/assets/images/placeholderImage.png')"
                                    draggable="false"
                                    class="hoverableImage"
                                    style="width: 35px; height: 35px; border-radius: 50%; object-fit: cover; border: 2px solid #3F51B5; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);"
                                  >
                                </template>
                              </template>
                            </v-hover>
                            <div>
                              <p style="white-space: nowrap;">{{ row.item.productName }}</p>
                              <p style="white-space: nowrap; font-size: smaller; color: #3F51B5;"><strong>{{ row.item.productSKU }}</strong></p>
                            </div>
                          </div>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupProductAmount' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <template v-if="row.item.selected">
                            <v-text-field
                              v-model="row.item.CRMWhatsappProductFollowupProductAmount"
                              @update:model-value="navigation.updateField = 'CRMWhatsappProductFollowupProductAmount'; navigation.updateValue = row.item.CRMWhatsappProductFollowupProductAmount; input.CRMWhatsappProductFollowupProduct.forEach(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected ? currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount = row.item.CRMWhatsappProductFollowupProductAmount : null);"
                              @keypress="$generalFunctions.default.allowOnlyNumberOnInputWithDecimal($event)"
                              @keydown.enter.prevent="navigation.updateField = null; navigation.updateValue = null; input.allCRMWhatsappProductFollowupProductSelected = false; input.CRMWhatsappProductFollowupProduct.forEach(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected = false);"
                              :loading="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
                              :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog || (navigation.updateField != null && navigation.updateField != 'CRMWhatsappProductFollowupProductAmount')"
                              label="Cantidad"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              clearable
                              hide-details
                            ></v-text-field>
                          </template>
                          <template v-else>
                            <p>{{ $displayFunctions.default.parseAmountToDisplay(row.item.CRMWhatsappProductFollowupProductAmount) }}</p>
                          </template>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupProductStock' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <v-chip
                            :color="row.item.productStockAmount >= row.item.CRMWhatsappProductFollowupProductAmount ? 'success' : 'error'"
                            variant="flat"
                            elevation="2"
                            density="compact"
                            label
                          >
                            <p>{{ row.item.productStockAmount >= row.item.CRMWhatsappProductFollowupProductAmount ? 'Inventario disponible' : 'Inventario insuficiente' }} <strong>({{ $displayFunctions.default.parseAmountToDisplay(row.item.productStockAmount) }})</strong></p>
                          </v-chip>
                        </template>
                        <template v-else-if="header.value == 'CRMWhatsappProductFollowupProductNote' && display.CRMWhatsappProductFollowupProductHeaders.find(currentCRMWhatsappProductFollowupProductHeader => currentCRMWhatsappProductFollowupProductHeader.value == header.value).visible">
                          <template v-if="row.item.selected">
                            <v-textarea
                              v-model="row.item.CRMWhatsappProductFollowupProductNote"
                              @update:model-value="navigation.updateField = 'CRMWhatsappProductFollowupProductNote'; navigation.updateValue = row.item.CRMWhatsappProductFollowupProductNote; input.CRMWhatsappProductFollowupProduct.forEach(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected ? currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote = row.item.CRMWhatsappProductFollowupProductNote : null);"
                              @keydown.enter.prevent="navigation.updateField = null; navigation.updateValue = null; input.allCRMWhatsappProductFollowupProductSelected = false; input.CRMWhatsappProductFollowupProduct.forEach(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected = false);"
                              :loading="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
                              :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog || (navigation.updateField != null && navigation.updateField != 'CRMWhatsappProductFollowupProductNote')"
                              label="Nota del seguimiento (opcional)"
                              clear-icon="mdi-backspace"
                              variant="outlined"
                              density="compact"
                              autocomplete="off"
                              rows="2"
                              no-resize
                              clearable
                              hide-details
                              style="margin: 10px 0px;"
                            ></v-textarea>
                          </template>
                          <template v-else>
                            <template v-if="row.item.CRMWhatsappProductFollowupProductNote != null && /\S/.test(row.item.CRMWhatsappProductFollowupProductNote)">
                              <p style="width: 400px; max-height: 150px; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #3F51B5 transparent;">{{ row.item.CRMWhatsappProductFollowupProductNote }}</p>
                            </template>
                            <template v-else>
                              <p style="font-size: x-small; color: #9e9e9e; white-space: nowrap;">Sin nota</p>
                            </template>
                          </template>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-slot:bottom></template>
              </v-data-table>
            </template>
            <template v-else>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 15px; gap: 5px; height: 150px;">
                <v-icon color="tertiary" size="small">mdi-information</v-icon>
                <p style="color: #9e9e9e; font-size: small;">No se ha encontrado ningún producto asociado a este seguimiento de producto</p>
              </div>
            </template>
            <template v-if="computed_CRMWhatsappProductFollowupProduct.length > 0">
              <v-card elevation="0" rounded="0" color="indigo" style="height: 2px;"></v-card>
              <v-card elevation="0" rounded="0" color="primary" class="footer">
                <div style="display: flex; gap: 10px; align-items: center;">
                  <template v-if="navigation.updateField != null">
                    <p>Actualizando la {{ {'CRMWhatsappProductFollowupProductAmount': 'cantidad', 'CRMWhatsappProductFollowupProductNote': 'nota'}[navigation.updateField] }} de <strong>{{ computed_CRMWhatsappProductFollowupProductSelectedCount }}</strong> producto{{ computed_CRMWhatsappProductFollowupProductSelectedCount > 1 ? 's' : '' }} seleccionado{{ computed_CRMWhatsappProductFollowupProductSelectedCount > 1 ? 's' : '' }}</p>
                    <v-btn
                      @click="input.CRMWhatsappProductFollowupProduct.forEach(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected ? (currentCRMWhatsappProductFollowupProduct[navigation.updateField] = navigation.updateValue, currentCRMWhatsappProductFollowupProduct.selected = false) : null); navigation.updateField = null; navigation.updateValue = null; input.allCRMWhatsappProductFollowupProductSelected = false;"
                      :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
                      color="success"
                      density="comfortable"
                      class="hoverableVButton"
                    >
                      <v-icon start size="small">mdi-check-circle</v-icon>
                      <p style="font-size: small">CONFIRMAR</p>
                    </v-btn>
                  </template>
                  <template v-else-if="computed_CRMWhatsappProductFollowupProductSelectedCount > 0">
                    <p><strong>{{ computed_CRMWhatsappProductFollowupProductSelectedCount }}</strong> producto{{ computed_CRMWhatsappProductFollowupProductSelectedCount > 1 ? 's' : '' }} seleccionado{{ computed_CRMWhatsappProductFollowupProductSelectedCount > 1 ? 's' : '' }}</p>
                  </template>
                </div>
                <div class="paginationContainer">
                  <v-pagination
                    v-model="navigation.CRMWhatsappProductFollowupProductPage"
                    @update:model-value="navigation.action == 'insert' ? null : selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog()"
                    :length="Math.ceil((navigation.action == 'insert' ? input.CRMWhatsappProductFollowupProduct.length : display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductCount) / navigation.CRMWhatsappProductFollowupProductLimit)"
                    :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog"
                    :total-visible="5"
                    density="compact"
                    size="small"
                  ></v-pagination>
                  <template v-if="navigation.action == 'insert'">
                    <p style="font-size: x-small;">{{ (input.CRMWhatsappProductFollowupProduct.length == 0) ? '0 de 0 productos' : `${(navigation.CRMWhatsappProductFollowupProductPage - 1) * navigation.CRMWhatsappProductFollowupProductLimit + 1} - ${Math.min(navigation.CRMWhatsappProductFollowupProductPage * navigation.CRMWhatsappProductFollowupProductLimit, input.CRMWhatsappProductFollowupProduct.length)} de ${input.CRMWhatsappProductFollowupProduct.length} productos`}}</p>
                  </template>
                  <template v-else>
                    <p style="font-size: x-small;">{{ (display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductCount == 0) ? '0 de 0 productos' : `${(navigation.CRMWhatsappProductFollowupProductPage - 1) * navigation.CRMWhatsappProductFollowupProductLimit + 1} - ${Math.min(navigation.CRMWhatsappProductFollowupProductPage * navigation.CRMWhatsappProductFollowupProductLimit, display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductCount)} de ${display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductCount} productos`}}</p>
                  </template>
                </div>
              </v-card>
            </template>
          </v-card>
        </div>
        <template v-if="['insert', 'update', 'delete'].includes(navigation.action)">
          <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px; flex-shrink: 0;"></v-card>
          <v-card color="primary" elevation="0" rounded="0" style="padding: 15px; flex-shrink: 0;">
            <v-tooltip
              :disabled="validateInputForDialog(false).success == true"
              location="top"
            > 
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  style="cursor: pointer;"
                >
                  <v-btn 
                    @click="navigation.action == 'insert' ? insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog() : (navigation.action == 'update' ? updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog() : deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog())" 
                    :disabled="loader.startup || loader.action || loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog || validateInputForDialog(false).success == false" 
                    color="indigo" 
                    block 
                    class="hoverableVButton"
                  >
                    <v-icon start size="large">mdi-source-branch-sync</v-icon>
                    <v-icon start>{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.action] }}</v-icon>
                    <h3>{{ {'insert': 'REGISTRAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.action] }} SEGUIMIENTO DE PRODUCTO</h3>
                  </v-btn>
                </div>
              </template>
              <span style="max-width: 400px; display: block;">{{ validateInputForDialog(false).result }}</span>
            </v-tooltip>
          </v-card>
        </template>
      </template>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
  .titleContainer {
    display: flex;
    align-items: center;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  .twoColumnContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .paginationContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 10px;
  }
  .paginationContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: auto;
  }
  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .actionsContainer {
      margin-left: 0;
      justify-content: center;
    }
    .twoColumnContainer {
      grid-template-columns: 1fr;
    }
    .footer {
      flex-direction: column;
      justify-content: center;
    }
    .paginationContainer {
      margin-left: 0;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components:
    {
      AppLoaderScreen
    },
    data: () => 
    ({
      input:
      {
        CRMWhatsappProductFollowupStatus: null,
        CRMWhatsappProductFollowupNote: null,
        CRMWhatsappProductFollowupProduct: [],
        productID: null,
        searchedProductID: null,
        allCRMWhatsappProductFollowupProductSelected: false
      },
      display: 
      {
        CRMWhatsappProductFollowup: null,
        CRMWhatsappProductFollowupProductHeaders: [],
        product: []
      },
      navigation: 
      {
        dialogIsVisible: false,
        fullScreen: false,
        action: null,
        CRMWhatsappContactID: null,
        CRMWhatsappProductFollowupID: null,
        CRMWhatsappConversationID: null,
        callbackFunction: null,
        updateField: null,
        CRMWhatsappProductFollowupProductPage: 1,
        CRMWhatsappProductFollowupProductLimit: 100
      },
      loader: 
      {
        startup: false,
        action: false,
        selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),
    computed:
    {
      computed_CRMWhatsappProductFollowupProductHeaders(){
        return this.display.CRMWhatsappProductFollowupProductHeaders.slice().sort((CRMWhatsappProductFollowupProductHeaderA, CRMWhatsappProductFollowupProductHeaderB) => CRMWhatsappProductFollowupProductHeaderA.index - CRMWhatsappProductFollowupProductHeaderB.index);
      },
      computed_CRMWhatsappProductFollowupProduct(){
        return ['insert', 'update'].includes(this.navigation.action) ? this.input.CRMWhatsappProductFollowupProduct : this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProduct;
      },
      computed_CRMWhatsappProductFollowupProductSelectedCount(){
        return this.input.CRMWhatsappProductFollowupProduct.filter(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.selected).length;
      }
    },
    methods:
    {
      async selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog(){
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappProductFollowupID': this.navigation.CRMWhatsappProductFollowupID
        };
        const selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog', selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody);
        if (selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult.success){
          this.display.CRMWhatsappProductFollowup = selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult.result;
          if (['insert', 'update'].includes(this.navigation.action)){
            this.input.CRMWhatsappProductFollowupStatus = this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupStatus;
            this.input.CRMWhatsappProductFollowupNote = this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupNote;
            this.input.CRMWhatsappProductFollowupProduct = this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProduct.map(currentCRMWhatsappProductFollowupProduct => ({
              'selected': false,
              ...currentCRMWhatsappProductFollowupProduct
            }));
          }
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar el seguimiento de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeDialog();
        }
      },
      async selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog(){
        this.loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog = true;
        const selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialogRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappProductFollowupID': this.navigation.CRMWhatsappProductFollowupID,
          'page': this.navigation.CRMWhatsappProductFollowupProductPage,
          'limit': this.navigation.CRMWhatsappProductFollowupProductLimit
        };
        const selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog', selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialogRequestBody);
        if (selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialogResult.success){
          this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct = selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialogResult.result;
          this.input.CRMWhatsappProductFollowupProduct = this.display.CRMWhatsappProductFollowup.CRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProduct.map(currentCRMWhatsappProductFollowupProduct => ({
            'selected': false,
            ...currentCRMWhatsappProductFollowupProduct
          }));
          this.input.allCRMWhatsappProductFollowupProductSelected = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar los productos del seguimiento de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeDialog();
        }
        this.loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog = false;
      },
      async selectProductForInput(){
        const selectProductForInputRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectProductForInputResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/product/functions/selectProductForInput', selectProductForInputRequestQuery);
        if (selectProductForInputResult.success){
          const product = selectProductForInputResult.result;
          product.forEach(currentProduct => {
            currentProduct.productAutocompleteTitle = `${currentProduct.productID} - ${currentProduct.productName}`;
          });
          this.display.product = product;
        } else this.$root.notificationDialog.showSystemNotificationDialog('selectProductForInput_error', 'error', 'Ha ocurrido un error inesperado al consultar los productos, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
      },
      async insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog(){
        this.loader.action = true;
        if (this.validateInputForDialog(true).success){
          const insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappProductFollowupCRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappProductFollowupStatus': this.input.CRMWhatsappProductFollowupStatus,
            'CRMWhatsappProductFollowupNote': this.input.CRMWhatsappProductFollowupNote,
            'CRMWhatsappProductFollowupCreationCRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
            'CRMWhatsappProductFollowupProduct': this.input.CRMWhatsappProductFollowupProduct.map(currentCRMWhatsappProductFollowupProduct => ({
              'CRMWhatsappProductFollowupProductProductID': currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductProductID,
              'CRMWhatsappProductFollowupProductAmount': currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount,
              'CRMWhatsappProductFollowupProductNote': currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote
            }))
          };
          const insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog', insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody);
          if (insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_success', 'success', 'Se ha registrado el seguimiento de producto exitosamente', null, true);
            if (this.navigation.callbackFunction != null) this.navigation.callbackFunction();
            this.closeDialog();
          } else this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_error', 'error', 'Ha ocurrido un error inesperado al registrar el seguimiento de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.action = false;
      },
      async updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog(){
        this.loader.action = true;
        if (this.validateInputForDialog(true).success){
          const updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
            },
            'CRMWhatsappProductFollowupID': this.navigation.CRMWhatsappProductFollowupID,
            'CRMWhatsappProductFollowupStatus': this.input.CRMWhatsappProductFollowupStatus,
            'CRMWhatsappProductFollowupNote': this.input.CRMWhatsappProductFollowupNote,
            'CRMWhatsappProductFollowupProduct': this.input.CRMWhatsappProductFollowupProduct.map(currentCRMWhatsappProductFollowupProduct => ({
              'CRMWhatsappProductFollowupProductProductID': currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductProductID,
              'CRMWhatsappProductFollowupProductAmount': currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount,
              'CRMWhatsappProductFollowupProductNote': currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote
            }))
          };
          const updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog', updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody);
          if (updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_success', 'success', 'Se ha actualizado el seguimiento de producto exitosamente', null, true);
            if (this.navigation.callbackFunction != null) this.navigation.callbackFunction();
            this.closeDialog();
          } else this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_error', 'error', 'Ha ocurrido un error inesperado al actualizar el seguimiento de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.action = false;
      },
      async deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog(){
        this.loader.action = true;
        const deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappProductFollowupID': this.navigation.CRMWhatsappProductFollowupID
        };
        const deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFollowup/functions/deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog', deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogRequestBody);
        if (deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialogResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_success', 'success', 'Se ha eliminado el seguimiento de producto exitosamente', null, true);
          if (this.navigation.callbackFunction != null) this.navigation.callbackFunction();
          this.closeDialog();
        } else this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog_error', 'error', 'Ha ocurrido un error inesperado al eliminar el seguimiento de producto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.loader.action = false;
      },
      appendProductIntoCRMWhatsappProductFollowupProduct(){
        if (this.input.productID != null){
          const displayProduct = this.display.product.find(currentProduct => currentProduct.productID == this.input.productID);
          if (displayProduct != null){
            const inputProduct = this.input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductProductID == displayProduct.productID);
            if (inputProduct == null){
              this.input.CRMWhatsappProductFollowupProduct.unshift({
                'selected': false,
                'CRMWhatsappProductFollowupProductProductID': displayProduct.productID,
                'productImageURL': displayProduct.productImageURL,
                'productName': displayProduct.productName,
                'productSKU': displayProduct.productSKU,
                'CRMWhatsappProductFollowupProductAmount': 1,
                'CRMWhatsappProductFollowupProductNote': null
              });
            } else inputProduct.CRMWhatsappProductFollowupProductAmount = inputProduct.CRMWhatsappProductFollowupProductAmount + 1;
          } else this.$root.notificationDialog.showSystemNotificationDialog('appendProductIntoCRMWhatsappProductFollowupProduct(displayProduct == null)', 'warning', 'No se ha encontrado el producto seleccionado', null, false);  
          this.input.productID = null;
          this.input.searchedProductID = null;
          this.$generalFunctions.default.blurInput(this, 'productID');
        }
      },
      validateInputForDialog(showNotification){
        if (['insert', 'update'].includes(this.navigation.action)){
          const regularExpressionChecker = /\S/;
          const numericChecker = /^[0-9]+(\.[0-9]+)?$/;
          if (this.input.CRMWhatsappProductFollowupStatus == null){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappProductFollowupStatus == null', 'warning', 'Debes seleccionar un estado del seguimiento de producto', null, false);
            return {success: false, result: 'Debes seleccionar un estado del seguimiento de producto'};
          }
          if (this.input.CRMWhatsappProductFollowupNote != null && !regularExpressionChecker.test(this.input.CRMWhatsappProductFollowupNote)){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappProductFollowupNote != null && !regularExpressionChecker.test(this.input.CRMWhatsappProductFollowupNote)', 'warning', 'En caso de querer agregar una nota, esta debe contener al menos un carácter válido', null, false);
            return {success: false, result: 'En caso de querer agregar una nota, esta debe contener al menos un carácter válido'};
          }
          if (this.input.CRMWhatsappProductFollowupNote != null && this.input.CRMWhatsappProductFollowupNote.length > 65535){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappProductFollowupNote != null && this.input.CRMWhatsappProductFollowupNote.length > 65535', 'warning', 'La nota del seguimiento de producto no puede exceder los 65535 caracteres', null, false);
            return {success: false, result: 'La nota del seguimiento de producto no puede exceder los 65535 caracteres'};
          }
          if (this.input.CRMWhatsappProductFollowupProduct.length == 0){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_input.CRMWhatsappProductFollowupProduct.length == 0', 'warning', 'Debes seleccionar al menos un producto para el seguimiento de producto', null, false);
            return {success: false, result: 'Debes seleccionar al menos un producto para el seguimiento de producto'};
          }
          let notValidCRMWhatsappProductFollowupProduct = this.input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount == null || currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount < 1 || !numericChecker.test(currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount));
          if (notValidCRMWhatsappProductFollowupProduct){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_notValidCRMWhatsappProductFollowupProduct', 'warning', `La cantidad del producto ${notValidCRMWhatsappProductFollowupProduct.productName} debe ser un número mayor a 0`, null, false);
            return {success: false, result: `La cantidad del producto ${notValidCRMWhatsappProductFollowupProduct.productName} debe ser un número mayor a 0`};
          }
          notValidCRMWhatsappProductFollowupProduct = this.input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductAmount > 2147483647);
          if (notValidCRMWhatsappProductFollowupProduct){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_notValidCRMWhatsappProductFollowupProduct', 'warning', `La cantidad del producto ${notValidCRMWhatsappProductFollowupProduct.productName} no puede exceder 2147483647`, null, false);
            return {success: false, result: `La cantidad del producto ${notValidCRMWhatsappProductFollowupProduct.productName} no puede exceder 2147483647`};
          }
          notValidCRMWhatsappProductFollowupProduct = this.input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote != null && !regularExpressionChecker.test(currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote));
          if (notValidCRMWhatsappProductFollowupProduct){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_notValidCRMWhatsappProductFollowupProduct', 'warning', `La nota del producto ${notValidCRMWhatsappProductFollowupProduct.productName} debe contener al menos un carácter válido`, null, false);
            return {success: false, result: `La nota del producto ${notValidCRMWhatsappProductFollowupProduct.productName} debe contener al menos un carácter válido`};
          }
          notValidCRMWhatsappProductFollowupProduct = this.input.CRMWhatsappProductFollowupProduct.find(currentCRMWhatsappProductFollowupProduct => currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote != null && currentCRMWhatsappProductFollowupProduct.CRMWhatsappProductFollowupProductNote.length > 65535);
          if (notValidCRMWhatsappProductFollowupProduct){
            if (showNotification) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForDialog_notValidCRMWhatsappProductFollowupProduct', 'warning', `La nota del producto ${notValidCRMWhatsappProductFollowupProduct.productName} no puede exceder los 65535 caracteres`, null, false);
            return {success: false, result: `La nota del producto ${notValidCRMWhatsappProductFollowupProduct.productName} no puede exceder los 65535 caracteres`};
          }
        }
        return {success: true, result: null};
      },
      updateTableHeaderIndex(tableName, headerValue, headerIndexChange){
        const updatedTableHeader = this.display[`${tableName}Headers`].find(header => header.value == headerValue);
        const swappedTableHeader = this.display[`${tableName}Headers`].find(header => header.index == (this.display[`${tableName}Headers`].find(header => header.value == headerValue).index + headerIndexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        localStorage.setItem(`CRMWhatsappProductFollowupDialog_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      updateTableVisibility(tableName){
        localStorage.setItem(`CRMWhatsappProductFollowupDialog_${tableName}Headers`, JSON.stringify(this.display[`${tableName}Headers`]));      
      },
      getTableRowClass(tableName, item){
        if (tableName == 'CRMWhatsappProductFollowupProduct' && this.navigation.action != 'update'){
          if (this.loader.selectCRMWhatsappProductFollowupProductFromCRMWhatsappProductFollowupDialog) return 'loadingVDataTableRow';
          if (this.computed_CRMWhatsappProductFollowupProductSelectedCount > 0){
            if (item.selected) return 'selectedVDataTableRow';
            return 'bluredVDataTableRow';
          }
          if (item.productStockAmount >= item.CRMWhatsappProductFollowupProductAmount) return 'successVDataTableRow';
        }
        return null;
      },
      async prepareTables(){
        const CRMWhatsappProductFollowupProductHeaders = 
        [
          ...(['insert', 'update'].includes(this.navigation.action) ? [{title: null, value: 'select', icon: null, visible: true}] : []),
          ...(['insert', 'update'].includes(this.navigation.action) ? [{title: null, value: 'delete', icon: null, visible: true}] : []),
          ...(['select', 'delete'].includes(this.navigation.action) ? [{title: 'ID', value: 'CRMWhatsappProductFollowupProductID', icon: 'mdi-barcode', visible: true}] : []),
          {title: 'PRODUCTO', value: 'CRMWhatsappProductFollowupProduct', icon: 'mdi-package', visible: true},
          {title: 'CANTIDAD', value: 'CRMWhatsappProductFollowupProductAmount', icon: 'mdi-numeric', visible: true},
          ...(['select', 'delete'].includes(this.navigation.action) ? [{title: 'INVENTARIO', value: 'CRMWhatsappProductFollowupProductStock', icon: 'mdi-package', visible: true}] : []),
          {title: 'NOTA', value: 'CRMWhatsappProductFollowupProductNote', icon: 'mdi-text-box', visible: true}
        ].map((header, index) => ({ ...header, index: index }));
        let localStorageHeaders = JSON.parse(localStorage.getItem('CRMWhatsappProductFollowupDialog_CRMWhatsappProductFollowupProductHeaders') || JSON.stringify(CRMWhatsappProductFollowupProductHeaders));
        for (const localStorageHeader of localStorageHeaders){
          const CRMWhatsappProductFollowupProductHeader = CRMWhatsappProductFollowupProductHeaders.find(CRMWhatsappProductFollowupProductHeader => CRMWhatsappProductFollowupProductHeader.value == localStorageHeader.value);
          if (CRMWhatsappProductFollowupProductHeader){
            if (localStorageHeader.visible != null) CRMWhatsappProductFollowupProductHeader.visible = localStorageHeader.visible;
            if (localStorageHeader.index != null) CRMWhatsappProductFollowupProductHeader.index = localStorageHeader.index;
          }
        }
        this.display.CRMWhatsappProductFollowupProductHeaders = CRMWhatsappProductFollowupProductHeaders.slice().sort((CRMWhatsappProductFollowupProductHeaderA, CRMWhatsappProductFollowupProductHeaderB) => CRMWhatsappProductFollowupProductHeaderA.index - CRMWhatsappProductFollowupProductHeaderB.index);
      },
      async getSystemInformation(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappProductFollowupDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappProductFollowupDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      async openCRMWhatsappProductFollowupDialog(action, CRMWhatsappContactID, CRMWhatsappProductFollowupID, CRMWhatsappConversationID, callbackFunction){
        this.loader.startup = true;
        await this.getSystemInformation();
        this.navigation.dialogIsVisible = true;
        this.navigation.action = action;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappProductFollowupID = CRMWhatsappProductFollowupID;
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.callbackFunction = callbackFunction;
        await this.prepareTables();
        if (['select', 'update', 'delete'].includes(action)) await this.selectCRMWhatsappProductFollowupFromCRMWhatsappProductFollowupDialog();
        else this.$generalFunctions.default.focusInput(this, 'CRMWhatsappProductFollowupStatus');
        if (['insert', 'update'].includes(action)) await this.selectProductForInput();
        this.loader.startup = false;
      },
      closeDialog(){
        this.navigation.dialogIsVisible = false;
        this.$emit('closeCRMWhatsappProductFollowupDialog');
      }
    }
  }
</script>